<script>
import { getBemModifiers } from '~/src/plugins/bemModifiers';
import { getMergedClass } from '~/src/utils/vue';

export default {
    name: 'Heading',
    functional: true,
    render(h, { props, data, children }) {
        const { level = 1 } = data.attrs;
        return h(`h${level}`, {
            class: getMergedClass([
                'heading',
                `heading--h${level}`,
                ...getBemModifiers('heading', props.bemModifiers),
            ], data),
        }, children);
    },
};
</script>

<style lang="scss">
.heading {
    font-weight: $font-weight-bold;
    font-family: $goodHomeFontFamily;

    &--h1 {
        font-size: 42px;
        line-height: 70px;
    }

    &--h2 {
        font-size: 33px;
        line-height: 56px;
    }

    &--h3 {
        font-size: 26px;
        line-height: 46px;
    }

    &--h4 {
        font-size: 20px;
        line-height: 38px;
    }

    &--h5 {
        font-size: 16px;
        line-height: 32px;
    }

    &--h6 {
        font-size: 13px;
        line-height: 27px;
    }

    &--font-weight-light {
        font-weight: $font-weight-light;
    }

    &--font-weight-regular {
        font-weight: $font-weight-regular;
    }

    &--adjust-line-height#{&} {
        &--h1,
        &--h2,
        &--h3,
        &--h4,
        &--h5,
        &--h6 {
            line-height: 1;
        }
    }


}
</style>
